import { useState } from 'react'
import Layout, { Card, Empty } from '@/components/Layout'
import { Link, router } from '@inertiajs/react'
import { useCanWrite } from '@/lib/access'
import type { GoalSummary } from '@/types'

export default function Index({ goals }: { goals: GoalSummary[] }) {
  const canWrite = useCanWrite()
  const [title, setTitle] = useState('')
  const [deadline, setDeadline] = useState('')
  const [target, setTarget] = useState('')

  const add = () => {
    if (!title.trim()) return
    router.post('/goals', { title, deadline, target_points: target }, {
      onSuccess: () => { setTitle(''); setDeadline(''); setTarget('') },
    })
  }

  return (
    <Layout>
      <Card title="🎯 目标" extra={<span className="text-[#707d90] text-[13px]">{goals.length ? `共 ${goals.length} 个 · 点开管理步骤` : ''}</span>}>
        {canWrite && (
          <div className="flex gap-2.5 flex-wrap items-center mb-3.5">
            <input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="新目标，例如：30 天跑完 5 公里" className="flex-1 min-w-[130px] border border-[#e7ebf2] rounded-[10px] px-2.5 py-2 outline-none focus:border-[#5b7cfa]" />
            <input type="date" value={deadline} onChange={(e) => setDeadline(e.target.value)} className="border border-[#e7ebf2] rounded-[10px] px-2.5 py-2 outline-none focus:border-[#5b7cfa]" />
            <input type="number" value={target} onChange={(e) => setTarget(e.target.value)} placeholder="总分门槛" min={0} className="w-[110px] border border-[#e7ebf2] rounded-[10px] px-2.5 py-2 outline-none focus:border-[#5b7cfa]" />
            <button onClick={add} className="bg-[#5b7cfa] text-white font-semibold px-4 py-2 rounded-[10px]">添加目标</button>
          </div>
        )}
        {goals.length ? goals.map((g) => (
          <Link key={g.id} href={`/goals/${g.id}`} className="block border border-[#e7ebf2] rounded-xl p-[15px] mb-3.5 last:mb-0 cursor-pointer hover:border-[#5b7cfa]">
            <div className="flex items-baseline gap-2.5 flex-wrap">
              <span className="font-bold text-base">{g.title}</span>
              {g.status === 'done'
                ? <span className="text-xs px-2.5 py-0.5 rounded-full bg-[#e7f8ee] text-[#2ec16b]">已达成</span>
                : <span className="text-xs px-2.5 py-0.5 rounded-full bg-[#eef2ff] text-[#5b7cfa]">进行中</span>}
              <span className="flex-1" />
              <span className="text-[#707d90] text-[13px]">{g.tasks_count} 个步骤 ›</span>
            </div>
            {g.target_points > 0 ? (
              <>
                <div className="h-2.5 bg-[#e7ebf2] rounded-full overflow-hidden my-2.5">
                  <div className="h-full rounded-full bg-gradient-to-r from-[#5b7cfa] to-[#8a5bfa]" style={{ width: `${g.progress_pct}%` }} />
                </div>
                <div className="text-[#707d90] text-[13px]">{g.earned} / {g.target_points} 分（{g.progress_pct}%）</div>
              </>
            ) : <div className="text-[#707d90] text-[13px] mt-1">已得 {g.earned} 分</div>}
          </Link>
        )) : <Empty>还没有目标，在上方添加一个吧。</Empty>}
      </Card>
    </Layout>
  )
}
